import { SearchOffers } from '@lambda/commons/apis/elasticsearch/types';
import { Product } from '@lambda/apis/src/product/types';
import { Options } from '@/lib/collection-search-helpers';
import { CollectionSearchResult } from '@/components/collections-v2/common/types';
import { useAbortableGetApi } from '@/lib/utils/use-abortable-api';

export const useCollectionSearchApi = (
  qs: string,
  initialData: {
    offers: Array<SearchOffers>;
    products?: Record<string, Product>;
    options?: Options;
    pagination?: {
      hasMore: boolean;
      page: number;
    };
  },
) =>
  useAbortableGetApi<CollectionSearchResult, typeof initialData>(
    '/api/collections/collection-search',
    qs,
    initialData,
    (data: CollectionSearchResult) => data,
    {
      errorMessage: 'Failed to fetch collection search results',
    },
  );
